export default __webpack_public_path__ + "static/expertise-cloud-19092436658c4300c618e15c9beec6c7.svg";